export const getUrlPrefix = (currentLanguage) => {
  return currentLanguage && currentLanguage !== `en`
    ? `/${currentLanguage}`
    : ``
}
